<div class="action-sheet-content">
    <ion-list class="action-sheet-content--actions-list" *ngIf="buttons?.length">
        <ion-item
            *ngFor="let button of buttons; last as isLast"
            [lines]="isLast ? 'none' : 'full'"
            [button]="true"
            (click)="itemClick(button)">
            <span>{{ button.text }}</span>
        </ion-item>
    </ion-list>

    <ion-list class="action-sheet-content--cancel-list">
        <ion-item
            *ngIf="showCancel"
            class="action-sheet-content--cancel"
            lines="none"
            [button]="true"
            (click)="itemClick(cancelButton)">
            <span>{{ cancelButton.text }}</span>
        </ion-item>
    </ion-list>
</div>
